import { GetProfile, RemoveProfile } from '@src/services/profile-page'

export const state = {
    profileInfo: {},
}

export const getters = {}

export const mutations = {
    SET_PROFILE(state, profileInfo) {
        state.profileInfo = profileInfo
    },
}

export const actions = {
    async fetchProfile({ commit }) {
        const resp = await GetProfile()
        if (resp.status === 200) {
            commit('SET_PROFILE', resp.data.data)
        }
        return resp
    },
    async removeProfile(_, profile) {
        const resp = await RemoveProfile(profile)
        return resp
    },
}
